export const notify = {
	type: 'common',
	group: 'main'
}
